// You can write your custom Javascript here

const header = document.querySelector('header.header');

if (header) {
  const updateHeight = () => {
    const height = header.offsetHeight;
    document.querySelector('body').style.setProperty('--header-height', `${height}px`);
  };

  // Initial set
  updateHeight();

  // Use ResizeObserver for more robust tracking of element size changes
  const resizeObserver = new ResizeObserver(() => {
    updateHeight();
  });

  resizeObserver.observe(header);

  // Fallback for older browsers/specific window resize events
  window.addEventListener('resize', updateHeight);

  console.log('Height tracker initialized. CSS variable --header-height is being updated.');
} else {
  console.error('Header element not found.');
}